// eslint-disable-next-line jira/import-whitelist
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { fetchQuery } from 'react-relay';
// eslint-disable-next-line jira/import-whitelist
import getRelayEnvironment from '@jira/platform__graphql-relay-environment/src/index.tsx';
import {
	createResource,
	useResource,
	type RouteResource,
	type UseResourceHookResponse,
} from '@atlassian/react-resource-router';
import ConfluenceUserPermissionsQuery, {
	type ConfluenceUserPermissionsQuery as ConfluenceUserPermissionsQueryType,
} from './__generated__/ConfluenceUserPermissionsQuery.graphql.ts';

export const confluenceUserPermissionsResource: RouteResource<{
	permitted: boolean;
} | null> = createResource<{ permitted: boolean } | null>({
	type: 'CONFLUENCE_USER_PERMISSIONS',
	getKey: (_routerContext, { tenantContext }) => {
		return tenantContext?.cloudId ?? 'current-cloud-id';
	},
	getData: async (_routerContext, { tenantContext }) => {
		try {
			const cloudId = tenantContext?.cloudId;
			if (!cloudId) {
				return null;
			}
			const data = await fetchQuery<ConfluenceUserPermissionsQueryType>(
				getRelayEnvironment(),
				ConfluenceUserPermissionsQuery,
				{
					resourceId: `ari:cloud:confluence::site/${cloudId}`,
					permissionId: 'write',
				},
				{ fetchPolicy: 'store-or-network' },
			).toPromise();

			if (!data) {
				return null;
			}
			return {
				permitted: !!data?.permitted,
			};
		} catch (error) {
			fireErrorAnalytics({
				error: error instanceof Error ? error : undefined,
				meta: {
					id: 'confluenceUserPermissionsResource',
					packageName: 'jiraConfluenceUserPermissionsResource',
					teamName: 'confluence-better-together',
				},
			});
			return null;
		}
	},
});

export function useConfluenceUserPermissionsResource(): UseResourceHookResponse<{
	permitted: boolean;
} | null> {
	return useResource(confluenceUserPermissionsResource);
}
